import { View } from "./Members.view";

export const Container = () => {
  return <View />;
};
